import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["styles"];

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React from "react";
export default (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === void 0 ? {} : _ref$styles,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00049 4C5.79146 4 4.00043 5.791 4.00043 8s1.79103 4 4.00006 4c2.20901 0 4.00011-1.791 4.00011-4s-1.7911-4-4.00011-4zm2.00001 4c0-1.103-.89699-2-2.00001-2-1.10302 0-2.00003.897-2.00003 2s.89701 2 2.00003 2c1.10302 0 2.00001-.897 2.00001-2z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0009 7.9996v3.001h-3.001v1.999h3.001v3h2.0001v-3H22v-1.999h-2.999v-3.001h-2.0001z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5131 12.8572c-.988.716-2.19899 1.143-3.51301 1.143-1.31302 0-2.52404-.427-3.51205-1.143-1.33502.725-2.25504 1.851-2.44704 3.143H2v4h12.0002v-4h-.04c-.192-1.292-1.112-2.418-2.4471-3.143zm.468 3.436c-.054-.367-.256-.73-.577-1.056-1.059.502-2.21399.763-3.40401.763-1.18902 0-2.34404-.261-3.40405-.763-.32101.326-.52201.689-.57601 1.056l-.02.129v1.578h8.00017v-1.596l-.0191-.111z",
    fill: "currentColor"
  }));
});